import { traverse, anyObj } from './../utils/traverse'
import { Operation } from './WPSClient';
type codigoArtifacts = { '*className*'?: string, '*classHierarchy*'?: string[] }

export const dePerl = (object: object): any => traverse(object, (o: codigoArtifacts & anyObj) => {
    const className = o['*className*']
    if (className) {
        const namespace = className.split(/[\.#]/);
        const coralShape = namespace.pop();
        o['__type'] = `${namespace.join('.')}#${coralShape}`;
        delete o['*className*']
    }
    delete o['*classHierarchy*']
    return o
})

export const operationToCamelCase = (op: Operation) => op[0].toLowerCase() + op.slice(1);

export const safeBool = (thing: '1' | '0' | 0 | 1 | true | false | undefined) => thing == true

export const isCustomEventSupported = (): boolean => {
    try {
        const event = new CustomEvent('test', { detail: 'supported' });
        return event.detail === 'supported';
    } catch (e) {
        return false;
    }
}

export class UnauthorizedError extends Error {
    constructor(msg: string) {
        super(msg);
        this.name = 'UnauthorizedError';
        Object.setPrototypeOf(this, UnauthorizedError.prototype);
    }
}

export class ForbiddenError extends Error {
    constructor(msg: string) {
        super(msg);
        this.name = 'ForbiddenError';
        Object.setPrototypeOf(this, ForbiddenError.prototype);
    }
}
